
function scrLct(e){
  var scllOffset = $('#'+e+'').offset();
  var scrollLct = scllOffset.top;
  var winScr = $(window).scrollTop();
  if($('#blogWrap .tapWrap').hasClass('fixed') === true ){
    if(scrollLct > winScr){
      scrollLct = scrollLct - 90;
      $('html,body').animate({scrollTop:scrollLct},500);
    } else{
      scrollLct = scrollLct - 90;
      $('html,body').animate({scrollTop:scrollLct},500);
    }
  } else{
    scrollLct = scrollLct - 130;
    $('html,body').animate({scrollTop:scrollLct},500);
  }
}


konnyScript(function($){
  $('#blogWrap .tapWrap button').click(function(){
    $('#blogWrap .tapWrap button').removeClass('on');
    $(this).addClass('on');
  });


    $('[id^=\'campaign_auto_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#campaign_auto_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#campaign_auto_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#campaign_auto_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#campaign_auto_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#campaign_auto_swiper_slide'+index+' .swiper-button-prev';
        var babySlide = new Swiper(this,{
            slidesPerView:1.2,
            slidesPerGroup:1,
            spaceBetween:15,
            centeredSlides:true,
            observer:true,
            observeParents:true,
            loop: true,
            speed: 3000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            breakpoints: {
                750: {
                    slidesPerView:3,
                    spaceBetween:20,
            		centeredSlides:false,
                    autoplay:false,
                    loop:false,
                },
            },
        });
    });
    
    
    
    $('[id^=\'campaign_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#campaign_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#campaign_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#campaign_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#campaign_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#campaign_swiper_slide'+index+' .swiper-button-prev';
        var mallSlide = new Swiper(this,{
            slidesPerView:1.1,
            slidesPerGroup:1,
            spaceBetween:20,
            centeredSlides:true,
            observer:true,
            observeParents:true,
            loop: true,
            pagination:true,
            pagination: {
                el: slidePage1,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            breakpoints: {
                750: {
                    slidesPerView: 3,
                    spaceBetween: 20,
            		centeredSlides:false,
                    loop: false,
                },
            },
        });
    });



    
    $('[id^=\'campaign_2_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#campaign_2_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#campaign_2_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#campaign_2_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#campaign_2_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#campaign_2_swiper_slide'+index+' .swiper-button-prev';
        var mallSlide = new Swiper(this,{
            slidesPerView:1,
            slidesPerGroup:1,
            spaceBetween:20,
            centeredSlides:true,
            observer:true,
            observeParents:true,
            loop: false,
            pagination:true,
            pagination: {
                el: slidePage1,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            breakpoints: {
                750: {
                    slidesPerView: 2,
                    spaceBetween: 20,
            		centeredSlides:false,
                },
            },
        });
    });


if($('#itvWrap01').length > 0){
  setTimeout(function(){
    var itvOfs01 = $('#itvWrap01').offset();
    itvOfs01 = itvOfs01.top;
    itvOfs01 = itvOfs01 - 100;
    var itvOfs02 = $('#itvWrap02').offset();
    itvOfs02 = itvOfs02.top;
    itvOfs02 = itvOfs02 - 100;
    var itvOfs03 = $('#itvWrap03').offset();
    itvOfs03 = itvOfs03.top;
    itvOfs03 = itvOfs03 - 100;
    if($('header').hasClass('is-sticky') === true){
        if($(document).scrollTop() > itvOfs03){
        $('#blogWrap .tapWrap').addClass('fixed');
            $('#blogWrap .tapWrap .tapBtn').removeClass('on');
            $('#blogWrap .tapWrap .tapBtn:nth-child(3)').addClass('on');
        }else if($(document).scrollTop() > itvOfs02){
            $('#blogWrap .tapWrap').addClass('fixed');
            $('#blogWrap .tapWrap .tapBtn').removeClass('on');
            $('#blogWrap .tapWrap .tapBtn:nth-child(2)').addClass('on');
        }else{
            $('#blogWrap .tapWrap').addClass('fixed');
            $('#blogWrap .tapWrap .tapBtn').removeClass('on');
            $('#blogWrap .tapWrap .tapBtn:nth-child(1)').addClass('on');
        }
    }else{
        $('#blogWrap .tapWrap').removeClass('fixed');
    }
  },1000)
}
  $(window).scroll(function(){
if($('#itvWrap01').length > 0){
      var itvOfs01 = $('#itvWrap01').offset();
      itvOfs01 = itvOfs01.top;
      itvOfs01 = itvOfs01 - 100;
      var itvOfs02 = $('#itvWrap02').offset();
      itvOfs02 = itvOfs02.top;
      itvOfs02 = itvOfs02 - 100;
      var itvOfs03 = $('#itvWrap03').offset();
      itvOfs03 = itvOfs03.top;
      itvOfs03 = itvOfs03 - 100;
      if($('header').hasClass('is-sticky') === true){
          if($(document).scrollTop() > itvOfs03){
          $('#blogWrap .tapWrap').addClass('fixed');
              $('#blogWrap .tapWrap .tapBtn').removeClass('on');
              $('#blogWrap .tapWrap .tapBtn:nth-child(3)').addClass('on');
          }else if($(document).scrollTop() > itvOfs02){
              $('#blogWrap .tapWrap').addClass('fixed');
              $('#blogWrap .tapWrap .tapBtn').removeClass('on');
              $('#blogWrap .tapWrap .tapBtn:nth-child(2)').addClass('on');
          }else{
              $('#blogWrap .tapWrap').addClass('fixed');
              $('#blogWrap .tapWrap .tapBtn').removeClass('on');
              $('#blogWrap .tapWrap .tapBtn:nth-child(1)').addClass('on');
          }
      }else{
          $('#blogWrap .tapWrap').removeClass('fixed');
      };
};
  });
});